import {FileNameData} from '../FileNameData';

export class WfApproveRequest {
    employeeId: number;
    operationRecordId: number;
    operationTableName: string;
    fileList?: FileNameData[];
}
